export default {
  apiBasePath:
    process.env.NODE_ENV === "production"
      ? `//${window.location.host}/api/`
      : "https://zh.zhichenghz.com/api/", //"http://localhost:8056/",
};
